/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failedtodeleteimage3Inputs */

const en_failedtodeleteimage3 = /** @type {(inputs: Failedtodeleteimage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to delete image`)
};

const de_failedtodeleteimage3 = /** @type {(inputs: Failedtodeleteimage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild konnte nicht gelöscht werden`)
};

/**
* | output |
* | --- |
* | "Failed to delete image" |
*
* @param {Failedtodeleteimage3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const failedtodeleteimage3 = /** @type {((inputs?: Failedtodeleteimage3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failedtodeleteimage3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_failedtodeleteimage3(inputs)
	return de_failedtodeleteimage3(inputs)
});
export { failedtodeleteimage3 as "failedToDeleteImage" }